import React from 'react';
import { services } from '../data/services';

export function ServicesSection() {
  return (
    <section id="services" className="py-16 sm:py-20 bg-gray-50" aria-labelledby="services-title">
      <div className="container mx-auto px-4 sm:px-6">
        <h2 
          id="services-title" 
          className="text-2xl sm:text-3xl font-bold text-center mb-12 sm:mb-16"
        >
          Our Legal Services
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition group"
            >
              <div className="mb-4 text-blue-600 group-hover:text-blue-700 transition-colors">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}